// extracted by mini-css-extract-plugin
module.exports = {"detailsButton":"JobListingJobCard_detailsButton__RAhvj"};